<template>
    <div>
        <div ref="editor" style="text-align:left"></div>
    </div>
</template>

<script>
    import E from 'wangeditor';
    export default {
        name: 'Editor',
        props:{
            content:[String],
        },
        data () {
            return {
                editorContent: ''
            };
        },
        watch:{
            content(){
                this.setContent(this.content);
            }
        },
        methods: {
            setContent(con){
                this.editor.txt.clear();
                let pureCon = this.filterHtml(con);
                this.editor.txt.html(pureCon);
                this.editorContent = pureCon;
            },
            getContent(){
                return this.editorContent||this.content;
            },
            getContentText(){
                return this.editorContent||this.content;
            },
            getEditorText(){
                return this.editor.txt.text();
            },
            stringToEntity(str){
                let div=document.createElement('div');
                div.innerText=str;
                div.textContent=str;
                let res=div.innerHTML;
                return res;
            },
            setDisabled(){
                this.editor.$textElem.attr('contenteditable', false);
            },
            clearEditor(){
                this.editor.txt.clear();
            },
            filterHtml(html){
                html = html.replace(/<style[^>]*>[\s\S]*?<\/[^>]*style>/gi,'');
                html = html.replace(/<script[^>]*>[\s\S]*?<\/[^>]*script>/gi,'');
                html = html.replace('<table border="0"','<table border="1" style="font-size:12px;border-collapse: collapse;"');
                html = html.replace(/<td[^>]*>[\s\S]*?<\/[^>]*td>/gi,function(text){
                    if(!text.includes('style="')){
                        text = text.replace(/<td/ig,'<td style="text-align:center; white-space:nowrap;"');
                    }
                    return text;
                });
                return html;
            }
        },
        mounted() {
            this.editor = new E(this.$refs.editor);
            this.editor.customConfig.onchangeTimeout = 30;
            this.editor.customConfig.onchange = (html) => {
                this.editorContent = html;
            };
            this.editor.create();

            if(this.content){
                this.editor.txt.html(this.content);
            }
        }
    };
</script>
